"use strict";
// import BN from 'bn.js';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSimulateValue = exports.parseSimulateLog = exports.simulateMultipleInstruction = exports.forecastTransactionSize = exports.getMultipleAccountsInfoWithCustomFlag = exports.getMultipleAccountsInfo = void 0;
// import { Spl, SPL_ACCOUNT_LAYOUT } from '../spl';
// import { TOKEN_PROGRAM_ID } from './id';
const web3_js_1 = require("@solana/web3.js");
const lodash_1 = require("./lodash");
const logger_1 = require("./logger");
const logger = new logger_1.Logger("Common.Web3");
// export async function batchGetMultipleAccountsInfo() {}
function getMultipleAccountsInfo(connection, publicKeys, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const { batchRequest, commitment } = Object.assign({
            batchRequest: false,
        }, config);
        const chunkedKeys = (0, lodash_1.chunkArray)(publicKeys, 100);
        let results = new Array(chunkedKeys.length).fill([]);
        if (batchRequest) {
            const batch = chunkedKeys.map((keys) => {
                const args = connection._buildArgs([keys.map((key) => key.toBase58())], commitment, "base64");
                return {
                    methodName: "getMultipleAccounts",
                    args,
                };
            });
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const unsafeResponse = yield connection._rpcBatchRequest(batch);
            results = unsafeResponse.map((unsafeRes) => {
                if (unsafeRes.error) {
                    return logger.throwError("failed to get info for multiple accounts", logger_1.Logger.errors.RPC_ERROR, {
                        message: unsafeRes.error.message,
                    });
                }
                return unsafeRes.result.value.map((accountInfo) => {
                    if (accountInfo) {
                        const { data, executable, lamports, owner, rentEpoch } = accountInfo;
                        if (data.length !== 2 && data[1] !== "base64") {
                            return logger.throwError("info must be base64 encoded", logger_1.Logger.errors.RPC_ERROR);
                        }
                        return {
                            data: Buffer.from(data[0], "base64"),
                            executable,
                            lamports,
                            owner: new web3_js_1.PublicKey(owner),
                            rentEpoch,
                        };
                    }
                    else {
                        return null;
                    }
                });
            });
        }
        else {
            try {
                results = yield Promise.all(chunkedKeys.map((keys) => connection.getMultipleAccountsInfo(keys, commitment)));
            }
            catch (error) {
                if (error instanceof Error) {
                    return logger.throwError("failed to get info for multiple accounts", logger_1.Logger.errors.RPC_ERROR, {
                        message: error.message,
                    });
                }
            }
        }
        return results.flat();
    });
}
exports.getMultipleAccountsInfo = getMultipleAccountsInfo;
function getMultipleAccountsInfoWithCustomFlag(connection, publicKeysWithCustomFlag, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const multipleAccountsInfo = yield getMultipleAccountsInfo(connection, publicKeysWithCustomFlag.map((o) => o.pubkey), config);
        return publicKeysWithCustomFlag.map((o, idx) => (Object.assign(Object.assign({}, o), { accountInfo: multipleAccountsInfo[idx] })));
    });
}
exports.getMultipleAccountsInfoWithCustomFlag = getMultipleAccountsInfoWithCustomFlag;
// export async function getTokenAccountsByOwner(
//   connection: Connection,
//   owner: PublicKey,
//   config?: GetTokenAccountsByOwnerConfig
// ) {
//   const defaultConfig = {};
//   const customConfig = { ...defaultConfig, ...config };
//   const solReq = connection.getAccountInfo(owner, customConfig.commitment);
//   const tokenReq = connection.getTokenAccountsByOwner(
//     owner,
//     {
//       programId: TOKEN_PROGRAM_ID
//     },
//     customConfig.commitment
//   );
//   const [solResp, tokenResp] = await Promise.all([solReq, tokenReq]);
//   const accounts: {
//     publicKey?: PublicKey;
//     mint?: PublicKey;
//     isAssociated?: boolean;
//     amount: BN;
//     isNative: boolean;
//   }[] = [];
//   for (const { pubkey, account } of tokenResp.value) {
//     // double check layout length
//     if (account.data.length !== SPL_ACCOUNT_LAYOUT.span) {
//       return logger.throwArgumentError('invalid token account layout length', 'publicKey', pubkey.toBase58());
//     }
//     const { mint, amount } = SPL_ACCOUNT_LAYOUT.decode(account.data);
//     const associatedTokenAddress = await Spl.getAssociatedTokenAddress({ mint, owner });
//     accounts.push({
//       publicKey: pubkey,
//       mint,
//       isAssociated: associatedTokenAddress.equals(pubkey),
//       amount,
//       isNative: false
//     });
//   }
//   if (solResp) {
//     accounts.push({
//       amount: new BN(solResp.lamports),
//       isNative: true
//     });
//   }
//   return accounts;
// }
/**
 * Forecast transaction size
 */
function forecastTransactionSize(instructions, signers) {
    if (instructions.length < 1) {
        return logger.throwArgumentError("no instructions provided", "instructions", instructions);
    }
    if (signers.length < 1) {
        return logger.throwArgumentError("no signers provided", "signers", signers);
    }
    const transaction = new web3_js_1.Transaction({
        recentBlockhash: "11111111111111111111111111111111",
        feePayer: signers[0],
    });
    transaction.add(...instructions);
    const message = transaction.compileMessage().serialize();
    // SIGNATURE_LENGTH = 64
    const transactionLength = signers.length + signers.length * 64 + message.length;
    return transactionLength;
}
exports.forecastTransactionSize = forecastTransactionSize;
/**
 * Simulates multiple instruction
 */
function simulateMultipleInstruction(connection, instructions) {
    return __awaiter(this, void 0, void 0, function* () {
        const feePayer = new web3_js_1.PublicKey("RaydiumSimuLateTransaction11111111111111111");
        const transactions = [];
        let transaction = new web3_js_1.Transaction({ feePayer });
        for (const instruction of instructions) {
            if (forecastTransactionSize([...transaction.instructions, instruction], [feePayer]) > web3_js_1.PACKET_DATA_SIZE) {
                transactions.push(transaction);
                transaction = new web3_js_1.Transaction({ feePayer });
                transaction.add(instruction);
            }
            else {
                transaction.add(instruction);
            }
        }
        if (transaction.instructions.length > 0) {
            transactions.push(transaction);
        }
        let results = [];
        try {
            results = yield Promise.all(transactions.map((transaction) => connection.simulateTransaction(transaction)));
        }
        catch (error) {
            if (error instanceof Error) {
                return logger.throwError("failed to simulate for instructions", logger_1.Logger.errors.RPC_ERROR, {
                    message: error.message,
                });
            }
        }
        const logs = [];
        for (const { value } of results) {
            if (value.logs) {
                logs.push(...value.logs);
            }
        }
        return logs;
    });
}
exports.simulateMultipleInstruction = simulateMultipleInstruction;
function parseSimulateLog(log, key) {
    const results = log.match(/{["\w:,]+}/g);
    if (!results || results.length !== 1) {
        return logger.throwArgumentError("simulate log fail to match json", "key", key);
    }
    return results[0];
}
exports.parseSimulateLog = parseSimulateLog;
function parseSimulateValue(log, key) {
    const reg = new RegExp(`"${key}":(\\d+)`, "g");
    const results = reg.exec(log);
    if (!results || results.length !== 2) {
        return logger.throwArgumentError("simulate log fail to match key", "key", key);
    }
    return results[1];
}
exports.parseSimulateValue = parseSimulateValue;
//# sourceMappingURL=web3.js.map